// Call state enum
export enum CallState {
  IDLE = 'idle', // Nothing
  PLACING = 'placing', // We are trying to place a call with the device
  RINGING = 'ringing', // The call is ringing
  IN_PROGRESS = 'in_progress',
  ACCEPTED = 'accepted',
  ENDED = 'ended',
}

// Base WebSocket message interface
export interface WebSocketMessage {
  action: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export interface CallSdpMessage extends WebSocketMessage {
  body?: {
    sdpDetails?: {
      type: 'offer' | 'answer' | 'pranswer' | 'rollback';
      value: string;
    };
  };
}

// Heartbeat ping message
export interface PingMessage extends WebSocketMessage {
  action: 'ping';
  ts: number;
}

// Heartbeat pong message
export interface PongMessage extends WebSocketMessage {
  action: 'pong';
  ts?: number;
}

// Call ringing message
export interface CallRingingMessage extends WebSocketMessage {
  action: 'callRinging';
}

// Call in progress message
export interface CallInProgressMessage extends CallSdpMessage {
  action: 'callInProgress';
}

// Call accepted message
export interface CallAcceptedMessage extends CallSdpMessage {
  action: 'callAccepted';
}

// Call updated message
export interface CallUpdatedMessage extends WebSocketMessage {
  action: 'callUpdated';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updates: any;
}

// Call update acknowledgment message
export interface CallUpdateAckMessage extends WebSocketMessage {
  action: 'callUpdateAck';
}

// Call updated response message
export interface CallUpdatedResponseMessage extends WebSocketMessage {
  action: 'callUpdatedResponse';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  response: any;
}

// Call accepted acknowledgment message
export interface CallAcceptedAckMessage extends WebSocketMessage {
  action: 'callAcceptedAck';
}

// End call message
export interface EndCallMessage extends WebSocketMessage {
  action: 'endCall';
  reason?: string;
}

// Device-initiated end call message
export interface DeviceEndCallMessage extends WebSocketMessage {
  action: 'device-end-call';
}
